import { frontendAnalyticsTrack } from 'analytics/utils';
import { hasSeenEstimates } from 'containers/Estimates/utils/hasSeenEstimates';
import {
  APPLICATION_FULL_PATH,
  BEST_FOR_YOU_FULL_PATH,
  MY_QUOTES_NEXT_STEPS_FULL_PATH,
  ESTIMATES_FULL_PATH,
  LIFESTYLE_TRAVEL_FULL_PATH,
  POLICY_OWNER_FULL_PATH,
} from 'routes/constants';
import { Source } from 'types/graph';
import { getFeatureExperiment } from 'util/optimizely/featureExperimentation';
import { Flags } from 'util/optimizely/types';

interface RoutingMap {
  [key: string]: Record<FunnelSplitUserPath, string> | undefined;
}

export enum FunnelSplitUserPath {
  highIncome = 'highIncome',
  digitalFirst = 'digitalFirst',
  agentLed = 'agentLed',
}

interface SplitFunnelResult {
  nextRoute: string | null;
  userPath: FunnelSplitUserPath;
}

function getRoutingMap(visitedEstimates: boolean): RoutingMap {
  return {
    [LIFESTYLE_TRAVEL_FULL_PATH]: {
      highIncome: APPLICATION_FULL_PATH,
      digitalFirst: APPLICATION_FULL_PATH,
      agentLed: visitedEstimates ? APPLICATION_FULL_PATH : ESTIMATES_FULL_PATH,
    },
    [ESTIMATES_FULL_PATH]: {
      highIncome: MY_QUOTES_NEXT_STEPS_FULL_PATH,
      digitalFirst: APPLICATION_FULL_PATH,
      agentLed: APPLICATION_FULL_PATH,
    },
    [APPLICATION_FULL_PATH]: {
      highIncome: BEST_FOR_YOU_FULL_PATH,
      digitalFirst: BEST_FOR_YOU_FULL_PATH,
      agentLed: MY_QUOTES_NEXT_STEPS_FULL_PATH,
    },
    // MLD-409 remove if Field UW Updates loses
    [POLICY_OWNER_FULL_PATH]: {
      highIncome: APPLICATION_FULL_PATH,
      digitalFirst: APPLICATION_FULL_PATH,
      agentLed: visitedEstimates ? APPLICATION_FULL_PATH : ESTIMATES_FULL_PATH,
    },
  };
}

interface SplitFunnelArgs {
  maritalStatus: boolean;
  currentRoute: string;
  income: number;
  age: number;
  digitalEligibility: boolean;
  lifeApplicationSource: Source | undefined;
  fireEvent?: boolean;
}
export const trackSplitTheFunnel = ({
  maritalStatus,
  age,
  userPath,
  income,
  digitalEligibility,
  lifeApplicationSource,
  currentRoute,
}: SplitFunnelArgs & { userPath: string }) => {
  const value = localStorage.getItem('hasFiredSplitTheFunnel');
  const hasFired = value ? JSON.parse(value) : false;

  if (!hasFired) {
    frontendAnalyticsTrack('Split the Funnel Path', {
      maritalStatus,
      currentRoute,
      age,
      path: userPath,
      income,
      eligible_for_digital: digitalEligibility,
      pgpro: lifeApplicationSource === Source.Pgpro,
    });
    localStorage.setItem('hasFiredSplitTheFunnel', JSON.stringify(true));
  }
};

export default function handleSplitFunnel({
  maritalStatus,
  currentRoute,
  income,
  age,
  digitalEligibility,
  lifeApplicationSource,
  fireEvent = true,
}: SplitFunnelArgs): SplitFunnelResult {
  const userPath = getUserPath(
    maritalStatus,
    income,
    age,
    digitalEligibility,
    lifeApplicationSource
  );

  console.log('userPath: ', userPath);

  if (fireEvent) {
    trackSplitTheFunnel({
      maritalStatus,
      currentRoute,
      age,
      userPath,
      income,
      digitalEligibility,
      lifeApplicationSource,
    });
  }

  const routingMap = getRoutingMap(hasSeenEstimates());

  return {
    nextRoute: routingMap[currentRoute]?.[userPath] ?? null,
    userPath,
  };
}

function getUserPath(
  maritalStatus: boolean,
  income: number,
  age: number,
  digitalEligibility: boolean,
  lifeApplicationSource: Source | undefined
): FunnelSplitUserPath {
  if (lifeApplicationSource === Source.Pgpro) {
    return FunnelSplitUserPath.agentLed;
  }

  const userAttributes = {
    maritalStatus,
    individualIncome: income,
    lifeDigitalEligibility: digitalEligibility,
    lifeApplicationSource,
    age,
  };

  console.log(userAttributes);
  const { enabled: isSplitFunnelAdjusting, variationKey } = getFeatureExperiment(
    Flags.SPLIT_FUNNEL_ADJUSTER,
    undefined,
    userAttributes
  );

  console.log(
    'Operations Flag Enabled:',
    isSplitFunnelAdjusting,
    'Returned Variation:',
    variationKey
  );

  if (isSplitFunnelAdjusting && variationKey != null) {
    return variationKey as FunnelSplitUserPath;
  }

  if (income > 100000 && age < 55) {
    console.log('highIncome me aa gaye hum');

    return FunnelSplitUserPath.highIncome;
  } else if (income <= 100000 && age <= 45 && digitalEligibility) {
    console.log('Why are we here?', income, age, digitalEligibility);

    return FunnelSplitUserPath.digitalFirst;
  }

  return FunnelSplitUserPath.agentLed;
}
